import { i18n_config_default } from './chunk-EJ2TIXJU.mjs';
import { __objRest, __spreadValues } from './chunk-T36PI2YV.mjs';
import { orderBy } from 'lodash';

var usersCardFactory = (users) => Object.values(users).map(
  (user) => ({
    id: user.organizationUserId,
    title: `${user.user.firstName} ${user.user.lastName}`,
    email: user.user.email,
    isActive: user.active,
    roleIds: user.roleIds,
    locationsCount: user.locationIds.length,
    activeFilter: user.active ? 1 : 2,
    supportUser: user.user.supportUser,
    resellerUser: user.user.resellerUser
  })
);
var getNormalUsersFactory = (users, shouldFilterAdminUsers = true) => Object.values(users).filter(
  (user) => !shouldFilterAdminUsers ? true : !user.user.supportUser && !user.user.resellerUser
).map(
  (user) => ({
    id: user.organizationUserId,
    title: `${user.user.firstName} ${user.user.lastName}`,
    email: user.user.email,
    isActive: user.active,
    roleIds: user.roleIds,
    locationsCount: user.locationIds.length,
    activeFilter: user.active ? 1 : 2,
    supportUser: user.user.supportUser,
    resellerUser: user.user.resellerUser
  })
);
var usersSelectionValuesFactory = (users, addEmail) => {
  return orderBy(
    Object.entries(users).reduce((acc, [key, user]) => {
      if (key !== "undefined")
        return [
          ...acc,
          {
            title: `${user.user.firstName} ${user.user.lastName}`,
            id: user.organizationUserId,
            isActive: user.active,
            topTagRight: (user == null ? void 0 : user.user.supportUser) ? i18n_config_default.t("commonTexts.ttSupport") : user.user.resellerUser ? i18n_config_default.t("commonTexts.support") : void 0,
            extraData: {
              supportUser: user.user.supportUser,
              resellerUser: user.user.resellerUser
            },
            description: addEmail ? user.user.email : void 0,
            roleIds: user.roleIds
          }
        ];
      return acc;
    }, []),
    (item) => item.title,
    "asc"
  );
};
var usersModalOptions = (users, currentUsers) => {
  const addedIds = new Set(currentUsers);
  const options = [];
  Object.values(users).forEach((_a) => {
    var _b = _a, { id } = _b, user = __objRest(_b, ["id"]);
    if (!addedIds.has(Number(id))) {
      options.push(__spreadValues({
        id
      }, user));
      addedIds.add(Number(id));
    }
  });
  return options;
};

export { getNormalUsersFactory, usersCardFactory, usersModalOptions, usersSelectionValuesFactory };
